// extracted by mini-css-extract-plugin
export default {"wrapper":"TableGroup_wrapper__V8P4T","item":"TableGroup_item__bAFop"};